
    import FeaturedImages from '../../components/Educations/FeaturedImages.vue';

    export default {
        async asyncData({ params, $axios }) {
            var slug = encodeURIComponent(params.slug);
            slug = slug.replace(/_/g, " ");

            var education;

            const results = await $axios.get(`/educations?slug=${slug}`);
            education = results.data.data;
            return { slug, education };
        },
        head() {
            return {
                title: this.education.title,
                meta: [
                    {
                        hid: 'og-title',
                        property: 'og:title',
                        content: this.education.title,
                    },
                    {
                        hid: 'og-url',
                        property: 'og:url',
                        content: 'https://nod.ba/edukacija/' + this.education.slug,
                    },
                    {
                        hid: 'og-type',
                        property: 'og:type',
                        content: 'website',
                    },
                    {
                        hid: 'og-image',
                        property: 'og:image',
                        content: (this.education.thumbnail) ? this.$axios.defaults.baseURL + '/image?imagePath=' + this.education.thumbnail : this.getPlaceholderImageFromLink(this.education.video)
                    },
                    
                    {
                        hid: 'description',
                        property: 'description',
                        content: this.education.short_description
                    },
                    {
                        hid: 'og-description',
                        property: 'og:description',
                        content: this.education.short_description
                    },
                    // other meta
                ],
            };
        },
        computed: {
            get_tab_class: (data) => (tab_name) => {
                var classes = "tab";
                if (data.active_tab == tab_name) {
                    classes += " active";
                }
                return classes;
            },
            is_tab_open: (data) => (tab_name) => {
                var classes = "tab__content";
                if (data.active_tab !== tab_name) {
                    classes += " closed";
                }
                else {
                }
                return classes;
            },
            get_lession_card_classes: (data) => (tab_index) => {
                var classes = "education__lession_expandable";
                if (data.current_lession_index === tab_index) {
                    classes += " expanded";
                }
                return classes;
            },
            get_tab_icon_src: (data) => (tab_index) => {
                if (data.current_lession_index === tab_index) {
                    return require("/assets/images/icons/minus.png");
                }
                else {
                    return require("/assets/images/icons/plus.png");
                }
            },
            get_lession_description_classes: (data) => (tab_index) => {
                var classes = "description";
                if (data.current_lession_index === tab_index) {
                    classes += " expanded";
                }
                return classes;
            }
        },
        data() {
            return {
                // education: null,
                // loading: true,
                active_tab: "description",
                current_lession_index: 0,
                previewing_education_video: false,
            };
        },
        created() {
            // this.fetchEducation();
        },
        mounted() {
            // console.log('Component mounted.')
        },
        methods: {
            async fetchEducation() {
                this.loading = true;
                const results = await this.$axios.get(`/educations?slug=${this.slug}`);
                this.education = results.data.data;
                this.loading = false;
            },
            setActiveTab(tab) {
                this.active_tab = tab;
            },
            setActiveLession(index) {
                this.current_lession_index = index;
            },
            register() {
                this.$refs.registration_form.show();
            },
            toAuthorPage() {
                const url = '/autor/' + this.education.education_creator.author_name.replace(/ /g, '_');
                this.$router.push(url);
            },
            getPlaceholderImageFromLink(yt_link){
                const parts = yt_link.split('/');
                const linkId = parts[parts.length - 1];
                return `http://img.youtube.com/vi/${linkId}/mqdefault.jpg`;

                // http://img.youtube.com/vi/<insert-youtube-video-id-here>/hqdefault.jpg
                // http://img.youtube.com/vi/<insert-youtube-video-id-here>/0.jpg
                // http://img.youtube.com/vi/<insert-youtube-video-id-here>/1.jpg
                // http://img.youtube.com/vi/<insert-youtube-video-id-here>/2.jpg
                // http://img.youtube.com/vi/<insert-youtube-video-id-here>/3.jpg

                
            },

            togglePreviewVideo(){
                this.previewing_education_video = !this.previewing_education_video;
            }
        },
        components: { FeaturedImages }
    }
